// Numbers — Latin digits, comma thousand separator (en-US).
// Currency — number + Arabic suffix " د.ع".
// Dates — dd/mm/yyyy (en-GB), 24h time.

const numberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0
});

const numberFormatterDecimal = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0
});

export function formatNumber(n, { decimals = 0 } = {}) {
  if (n == null || Number.isNaN(Number(n))) return '0';
  return decimals ? numberFormatterDecimal.format(Number(n)) : numberFormatter.format(Number(n));
}

export function formatIQD(n) {
  if (n == null || Number.isNaN(Number(n))) return '0 د.ع';
  return `${numberFormatter.format(Number(n))} د.ع`;
}

const dateFormatter = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
});

const timeFormatter = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
});

const dateTimeFormatter = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
});

function asDate(d) {
  if (!d) return null;
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatDate(d) {
  const date = asDate(d);
  if (!date) return '';
  // en-GB returns "dd/mm/yyyy"
  return dateFormatter.format(date);
}

export function formatTime(d) {
  const date = asDate(d);
  if (!date) return '';
  return timeFormatter.format(date);
}

export function formatDateTime(d) {
  const date = asDate(d);
  if (!date) return '';
  // en-GB returns "dd/mm/yyyy, hh:mm" — replace comma with space
  return dateTimeFormatter.format(date).replace(',', '');
}

export function formatDuration(minutes) {
  const m = Math.max(0, Math.floor(Number(minutes) || 0));
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h === 0) return `${mm} د`;
  return `${h}:${String(mm).padStart(2, '0')}`;
}

export function initialOf(name = '?') {
  const s = String(name).trim();
  if (!s) return '?';
  return s[0];
}

const palette = ['#FF7A1A', '#06B6D4', '#EC4899', '#FFB627', '#22C55E', '#8B5CF6', '#EF4444'];
export function colorFor(seed = '') {
  let h = 0;
  const s = String(seed);
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0;
  return palette[Math.abs(h) % palette.length];
}
